module.exports = "<style>.badge { margin-right: 3px; }</style>\n <h4>\n \t{{item.id_pensum}}\n </h4>\n<br>\n<p>\n\t<span class=\"font-bold\">Carrera:</span> {{item.careerName}}</br>\n\t<span class=\"font-bold\">Grado:</span> {{item.id_academic_period}}</br>\n\t<span class=\"font-bold\">Ciclo:</span> {{item.id_academic_period}}</br>\n\t<span class=\"font-bold\">Campus:</span> {{item.ds_campus}}</br>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/list-filter/templates/optimal-view.html
// module id = 219
// module chunks = 0